export default "__VITE_ASSET__e985a215__"